import React from 'react';
import styled from 'astroturf/react';
import $image_url from 'js/utils/image_url';

import routes from 'js/core_pre_webpack/routes';

import Carousel, { CarouselProps } from '../shared/Carousel';
import { userSentimentPopup } from './course_discovery_helper';

export interface Props {
  staffPick?: StaffPickProps;
  carousels: Array<CarouselProps>;
  showUserSentimentPopup?: boolean;
}

export interface StaffPickProps {
  courseId: string;
  instructorImagePath: string;
  title: string;
  instructorName: string;
}

const StaffPickContainer = styled.div`
  width: 100%;
  padding: 0px 16px;
  border-bottom: 1px solid #dddddd;
  background-color: #fff;

  @media screen and (min-width: 1024px) and (max-width: 1366px) {
    padding: 0px 50px;
  }
`;

const StaffPickContentContainer = styled.div`
  display: flex;
  flex-direction: row;
  min-height: 354px;
  max-width: 1130px;

  padding: 38px 0;

  margin: 0 auto;
  justify-content: space-between;
`;

const StaffPickInfoContainer = styled.div`
  flex-direction: column;
  width: 100%;

  @media screen and (min-width: 800px) {
    width: 50%;
  }
`;

const StaffPickBannerContainer = styled.div`
  width: 88.25px;
  height: 20px;
  position: relative;
  margin-bottom: 28px;
`;

const StaffPickBanner = styled.div`
  width: 88.25px;
  height: 20px;
  position: absolute;

  background: #0954d3;
  border-bottom-left-radius: 3px;
  border-top-left-radius: 3px;

  padding-left: 8px;
  font-family: Roboto;
  font-weight: bold;
  font-size: 10px;
  line-height: 20px;
  letter-spacing: 0.5px;
  color: #ffffff;
`;

const StaffPickBannerTriangle = styled.div`
  width: 0;
  height: 20px;
  right: 0px;
  position: absolute;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-right: 15px solid white;
`;

const StaffPickHeader = styled.div`
  margin-bottom: 8px;

  font-family: Roboto;
  font-weight: bold;
  font-size: 34px;
  line-height: 40px;
  color: #222222;
`;

const StaffPickSubHeader = styled.div`
  margin-bottom: 42px;

  font-family: Roboto;
  font-size: 22px;
  line-height: 29px;
  color: #222222;
  opacity: 0.9;
`;

const StaffPickButton = styled.button`
  width: 100%;
  height: 53px;

  background: #0954d3;
  border: none;
  border-radius: 3px;

  font-family: Roboto;
  font-weight: 500;
  font-size: 16px;
  color: #ffffff;

  @media screen and (min-width: 500px) {
    width: 144px;
    margin-right: 16px;
  }

  i {
    padding-left: 4px;
  }
`;

const StaffPickImageContainer = styled.div`
  display: none;
  position: relative;
  overflow: hidden;

  width: 415px;
  height: 330px;
  @media screen and (min-width: 800px) {
    display: inline;
  }
`;

const Rectangle = styled.div`
  position: absolute;
  width: 200px;
  height: 150px;
  border-radius: 4px;
  background-color: #d8e5f9;
  top: 34px;
  right: 0px;

  @media screen and (min-width: 950px) {
    width: 260px;
    height: 201px;
  }
`;

const InstructorImage = styled.img`
  position: absolute;
  width: 260px;
  top: 68px;
  right: 75px;

  @media screen and (min-width: 950px) {
    width: 340px;
    right: 65px;
  }
`;

const CarouselsContainer = styled.div`
  background: #f8f8f8;
  padding: 48px 0;
`;

function StaffPick(props: StaffPickProps) {
  const { courseId, instructorImagePath, title, instructorName } = props;

  return (
    <StaffPickContainer>
      <StaffPickContentContainer>
        <StaffPickInfoContainer>
          <StaffPickBannerContainer>
            <StaffPickBanner>STAFF PICK</StaffPickBanner>
            <StaffPickBannerTriangle />
          </StaffPickBannerContainer>
          <StaffPickHeader>{title}</StaffPickHeader>
          <StaffPickSubHeader>Taught by {instructorName}</StaffPickSubHeader>
          <StaffPickButton
            data-kale-component="staffPick"
            data-kale-collection="Courses"
            data-kale-data={JSON.stringify({
              course_id: courseId,
            })}
            onClick={(e) => {
              e.preventDefault();
              window.location.href = routes.course_url({ id: courseId });
            }}
          >
            Watch course <i className="fa fa-caret-right" />
          </StaffPickButton>
        </StaffPickInfoContainer>
        <StaffPickImageContainer>
          <Rectangle />
          <InstructorImage src={$image_url(instructorImagePath)} />
        </StaffPickImageContainer>
      </StaffPickContentContainer>
    </StaffPickContainer>
  );
}

export default function LoggedInDiscoveryPage(
  props: Props,
): React.ReactElement {
  const { staffPick, carousels, showUserSentimentPopup } = props;

  const sections = carousels.map((carousel, idx) => {
    return (
      <Carousel
        key={idx}
        categoryTitle={carousel.categoryTitle}
        courses={carousel.courses}
        page={'discoveryLoggedIn'}
        courseImpressionData={carousel.courseImpressionData}
      />
    );
  });
  return (
    <>
      {staffPick && (
        <StaffPick
          courseId={staffPick.courseId}
          instructorImagePath={staffPick.instructorImagePath}
          title={staffPick.title}
          instructorName={staffPick.instructorName}
        />
      )}
      <CarouselsContainer>{sections}</CarouselsContainer>
      {showUserSentimentPopup && userSentimentPopup}
    </>
  );
}
